import { useTranslation } from 'react-i18next';
import { MenuItem, Stack, TextField } from '@munifocus/ui';
import { useContactAssignees } from '../../lib/front-desk-api';

/** Assignee and due time for a callback. The caller's own name comes first. */
export function CallbackFields({
  localGovernmentId,
  meId,
  assigneeId,
  dueLocal,
  onAssignee,
  onDue,
}: {
  localGovernmentId: string | null;
  meId: string | null;
  assigneeId: string;
  dueLocal: string;
  onAssignee: (id: string) => void;
  onDue: (value: string) => void;
}) {
  const { t } = useTranslation();
  const assignees = useContactAssignees(localGovernmentId);
  const list = [...(assignees.data ?? [])].sort((a, b) =>
    a.id === meId ? -1 : b.id === meId ? 1 : a.displayName.localeCompare(b.displayName),
  );
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        select
        size="small"
        fullWidth
        label={t('gov.frontDesk.callback.assignee')}
        value={assigneeId}
        onChange={(e) => onAssignee(e.target.value)}
        slotProps={{ htmlInput: { 'data-testid': 'callback-assignee' } }}
      >
        {list.map((a) => (
          <MenuItem key={a.id} value={a.id}>
            {a.id === meId
              ? t('gov.frontDesk.callback.me', { name: a.displayName })
              : a.displayName}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        type="datetime-local"
        size="small"
        fullWidth
        label={t('gov.frontDesk.callback.due')}
        value={dueLocal}
        onChange={(e) => onDue(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
      />
    </Stack>
  );
}
